export default {
	blue: "#1c547e",
	white: "#FFFFFF"
}
